import { all } from 'redux-saga/effects';
import fetchClosedIncidents from './fetchClosedIncidents';

export default function* () {
    yield all([fetchClosedIncidents()]);
}
